import { Grid } from '@mui/material';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import ModalFooter from '../common/ModalFooter';
import Dropdown from '../common/Dropdown';
import FormField from '../common/FormField';
import InputField from '../common/InputField';
import Modal from '../common/Modal';

const AddAndEditPriceModal: React.FC<{
  control: any;
  handleSubmit: any;
  errors: any;
  onClose: () => void;
  open: boolean;
  defaultValues: any;
  productOptions?: { value: string | number; label: string }[];
  portOptions?: { value: string | number; label: string }[];
  submitting?: boolean;
  isEditMode?: boolean;
}> = ({
  control,
  handleSubmit,
  errors: _errors,
  onClose,
  open,
  defaultValues: _defaultValues,
  productOptions = [],
  portOptions = [],
  submitting = false,
  isEditMode = false,
}) => {
  const { t } = useTranslation();
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={isEditMode ? t('priceList.editProductPrice') : t('priceList.addProductPrice')}
      size="xs"
      footer={
        <ModalFooter
          onCancel={onClose}
          onSubmit={handleSubmit}
          isLoading={submitting}
          submitText={isEditMode ? t('buttons.update') : t('buttons.add')}
        />
      }
    >
      <Grid container pt={3}>
        <Grid size={{ xs: 12, md: 12 }}>
          <FormField label={t('form.product')}>
            <Controller
              name="productId"
              control={control}
              rules={{ required: t('form.product') + ' is required' }}
              render={({ field }: any) => (
                <Dropdown
                  {...field}
                  variant="outlined"
                  fullWidth
                  disabled={isEditMode}
                  options={productOptions}
                />
              )}
            />
          </FormField>
        </Grid>
        <Grid size={{ xs: 12, md: 12 }}>
          <FormField label={t('form.port')}>
            <Controller
              name="portId"
              control={control}
              rules={{ required: t('form.port') + ' is required' }}
              render={({ field }: any) => (
                <Dropdown
                  {...field}
                  variant="outlined"
                  fullWidth
                  disabled={isEditMode}
                  options={portOptions}
                />
              )}
            />
          </FormField>
        </Grid>
        <Grid size={{ xs: 12, md: 12 }}>
          <FormField label={t('form.price')}>
            <Controller
              name="price"
              control={control}
              rules={{ required: t('form.price') + ' is required' }}
              render={({ field }: any) => (
                <InputField {...field} variant="outlined" fullWidth type="number" />
              )}
            />
          </FormField>
        </Grid>
      </Grid>
    </Modal>
  );
};

export default AddAndEditPriceModal;
